import React, { useState, useEffect, useRef } from 'react';
import '../../../../assets/css/user/maintainance/qualitystandard/QualityStandard.css';

const SuccessCard = ({ stat }) => {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => {
      if (cardRef.current) {
        observer.unobserve(cardRef.current);
      }
    };
  }, [isVisible]);

  useEffect(() => {
    if (isVisible) {
      let start = 0;
      const end = stat.number;
      const duration = 2000; // 2 seconds
      const increment = end / (duration / 16);

      const timer = setInterval(() => {
        start += increment;
        if (start >= end) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(Math.floor(start));
        }
      }, 16);

      return () => clearInterval(timer);
    }
  }, [isVisible, stat.number]);

  return (
    <div 
      ref={cardRef}
      className={`stats-card ${isVisible ? 'animate-in' : ''}`}
    >
      <div className="stats-icon-wrapper">
        {stat.icon}
      </div>
      <h3 className="stats-number">{count}</h3>
      <p className="stats-label">{stat.label}</p>
    </div>
  );
};

export default SuccessCard;